import WaitList from './WaitList';

export default WaitList;
